import type { RouteRecordRaw, RouteComponent } from 'vue-router'
import { PageTypes } from '@core/constants/pages'
import { COUNTRY } from '@gifsa/language-utils/routes'

export function getCountryRoutes(component: RouteComponent): RouteRecordRaw[] {
  return COUNTRY.map(
    ({ url, lang }): RouteRecordRaw => ({
      name: `country-${lang}`,
      path: joinRoute(url, ':country'),
      meta: { pageType: PageTypes.COUNTRY, lang },
      component,
    }),
  )
}
